var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.986798 0H15.0131C15.8108 0 16.2777 0.955057 15.8194 1.64904L10.2966 10.0116C10.1802 10.1879 10.1178 10.398 10.1178 10.6134V15.1321C10.1178 15.4914 9.94447 15.8256 9.65867 16.0175L6.94943 17.8365C6.29343 18.2769 5.43817 17.7758 5.43817 16.951V10.5919C5.43817 10.3899 5.38323 10.1922 5.27996 10.0227L0.159834 1.61649C-0.264584 0.919685 0.205906 0 0.986798 0Z",
    fill: "#00A3E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.f2d5d89887ae202f0b95efc9bf898ad0.svg";
export { ForwardRef as ReactComponent };